<div class="fs-2 with-close" mat-dialog-title>
    Déposer ma facture
    <i class="fa fa-close" (click)="close()" aria-hidden="true"></i>
</div>

<div mat-dialog-content>
    <p>Pour être réglée, votre facture doit respecter les conditions suivantes :</p>
    <ul>
        <li>Un <b>montant HT égal à {{ data.remaining / 100 | number:'1.2-2' }} €</b> (+ TVA si vous y êtes assujetti).</li>
        <li>Être établie à l'ordre de <b>LyBox</b> et comporter vos coordonnées.</li>
        <li>Format <b>PDF</b> uniquement.</li>
    </ul>
    <p>Après validation, le règlement intervient sous <b>30 jours</b>. Le solde restant dû repasse à 0.</p>

    <div class="upload-zone">
        <input type="file" #fileInput accept="application/pdf,.pdf" hidden (change)="onFileSelected($event)">
        <button type="button" class="btn btn-outline" (click)="fileInput.click()">
            <i class="fa cfa cfa-pdf" aria-hidden="true"></i>
            {{ fileName ? 'Changer le fichier' : 'Choisir mon PDF' }}
        </button>
        <span class="file-name ms-2" *ngIf="fileName">{{ fileName }}</span>
    </div>

    <p class="text-danger mt-2 mb-0" *ngIf="error">{{ error }}</p>
</div>

<div mat-dialog-actions>
    <button type="button" class="btn btn-outline" (click)="close()" [disabled]="loading">Annuler</button>
    <button type="button" class="btn btn-primary" [disabled]="!file || loading" (click)="submit()">
        {{ loading ? 'Envoi en cours…' : 'Valider ma demande' }}
    </button>
</div>
